import React, { Component, createRef, } from 'react';
import * as _ from "lodash";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import BusinessIcon from '@material-ui/icons/Business';
import RoomIcon from '@material-ui/icons/Room';
import Accessrating from "./Accessrating.js";
import Services from '../../api/api';
import Rating from '@material-ui/lab/Rating';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import NearMeIcon from '@material-ui/icons/NearMe';
import SearchBar from "material-ui-search-bar";
import { removeSpacetoLowerCase } from '../../api/helper';
import imgUrl from "../../assets/images/imageUrl";

class GoogleMarkerList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      markerList: this.props.markerList,
    }
    this.handleOnSearch = this.handleOnSearch.bind(this);
  }

  handleClick(mark, param){
    if(window.cardova){
      if(window.cordova.plugins.launchnavigator){
        window.cordova.plugins.launchnavigator.navigate(
          [this.props.userposition[0],this.props.userposition[1]], 
          [mark.geometry.location.lat, mark.geometry.location.lng],
          function() {
          },
          function(error) {
          }, {
              preferGoogleMaps: true,
              enableDebug: true
          });
      }
    } else{
      var url = "http://maps.google.com/?saddr=" + this.props.userposition[0] + "," + this.props.userposition[1] + "&daddr=" + mark.geometry.location.lat + "," + mark.geometry.location.lng;
      window.open(url, "_system");
    }
  }

  handleOnSearch(e){
    let topicList = _.cloneDeep(this.props.markerList);
    let filtered = [];
    filtered = topicList.filter(function (str) {
      return removeSpacetoLowerCase(str.name).indexOf(removeSpacetoLowerCase(e)) !== -1;
    });
    if (e.length == 0) {
      filtered = _.cloneDeep(this.props.markerList);
    }
    this.setState({
      markerList: filtered,
    });
  }



  render() {
    var list = []
    if (this.state.markerList.length > 0) {
      this.state.markerList.map((mark, i) => {
        list.push(
          <Grid key={i} container spacing={3} className="gridcontainer maplistcontainerdiv">
            <Grid item xs={2} className="zero text-center">
              <p className="zero hospitalicon"><img src={imgUrl.mapdefult} /> </p>
            </Grid>
            <Grid item xs={10} className="zero">
              <p className="zero listname">{mark.name} <button className="nearmebutton" onClick={() => this.handleClick(mark)}><NearMeIcon></NearMeIcon></button> </p>
              <p className="zero listsubtext">Category: {mark.types[0]}</p>
              <p className="zero listsubtext">Address : {mark.vicinity}</p>
            </Grid>
          </Grid>
        )
      })
    }
    return (
      <div>
      <SearchBar
        className="getaccess-searchbar"
        onChange={this.handleOnSearch}
      />
      <div>{list}</div>
    </div>
    )
  }
}

export default GoogleMarkerList;